import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import getBrandFromUrl from "../../utils/getBrandFromUrl";
import getCountryFromURL from "../../utils/getCountryFromUrl";
import * as constants from "../../utils/constants";
import { apiURI } from "../../env";

import _ from "lodash";

import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Container,
  Divider,
  Hidden,
  IconButton,
  Fab,
} from "@material-ui/core";
import { Typography, TextField, Button } from "@packages/ui";


import SnackBar from "../../layouts/SnackBar";

import * as checkinActions from "src/actions/checkinActions";

import { ThemeProvider } from "react-jss";
import moment from "moment";

import { theme } from "../../components/ui/theme";
import { makeStyles } from "@material-ui/core/styles";


import CloseIcon from "@material-ui/icons/Close";
import KeyboardArrowRightSharpIcon from '@material-ui/icons/KeyboardArrowRightSharp';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100vw",
    height: "100vh",
  },
  bold: {
    fontWeight: 600,
  },
  icon: {
    width: "150px"
  }


}));

const CheckinComplete = () => {
  const dispatch = useDispatch();
  const checkin = useSelector((state) => state.checkin);
  const isDemo = useSelector((state) => state.checkin.isDemo);
  const isAdditionalDriver = useSelector((state) => state.checkin.isAdditionalDriver);
  const navigate = useNavigate()

  const classes = useStyles();
  let termsAndConditionsUrl = "";
  let icon_Url_Complete1;
  let themeColor;

  const [willExpire, setWillExpire] = React.useState(false);
  const [letSessionExpire, setLetSessionExpire] = React.useState(false);
  const [sessionTracker, setSessionTracker] = React.useState(null);

  const reservationNumber = React.useMemo(() => {
    return checkin.resNo;
  }, [checkin.resNo]);

  const randomNumber = React.useMemo(() => {
    return Math.random();
  }, [checkin.resNo]);

  const brand = getBrandFromUrl();
  const country = getCountryFromURL();
  const verifiedTime = new Date(checkin.idVerification.VerifiedTime).toLocaleDateString();

  React.useEffect(() => {
    setLetSessionExpire(false);
    clearInterval(sessionTracker);
    setSessionTracker(
      setInterval(() => {
        const sessionExpiry = _.get(checkin, "auth.expires", moment().subtract(0, "m").unix());
        if (moment().isAfter(moment.unix(sessionExpiry))) {
          window.location.replace(`/${isDemo ? 'checkin-demo' : 'checkin'}/login`);
        }
        const isExpiring = moment().add(2, "m").isAfter(moment.unix(sessionExpiry));
        setWillExpire(isExpiring);
      }, 10000)
    );
    setWillExpire(false);
  }, [checkin.auth.expires]);

  const onExtendSession = () => {
    dispatch(checkinActions.extendSession());
  };

  const handleClickDownButton = (id) => {
    const element = document.getElementById(id);
    element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  };

  const onClickHandler = () => {
    navigate(`/${isDemo ? 'checkin-demo' : 'checkin'}/verify`)
  }

  if (country == "NZ") {
    switch (brand) {
      case "Ace":
        termsAndConditionsUrl = constants.ACE_TERMS_NZ_PDF;
        break;
      case "Dollar":
        termsAndConditionsUrl = constants.DOLLAR_TERMS_NZ;
        break;

      case "Thrifty":
        termsAndConditionsUrl = constants.THRIFTY_TERMS_NZ;
        break;

      default:
        termsAndConditionsUrl = constants.HERTZ_TERMS_NZ_PDF;
        break;

    }

  } else if (country == "AU") {
    switch (brand) {
      case "Ace":
        termsAndConditionsUrl = constants.ACE_TERMS_AU_PDF;
        break;

      case "Dollar":
        termsAndConditionsUrl = constants.DOLLAR_TERMS_AU;
        break;

      case "Thrifty":
        termsAndConditionsUrl = constants.THRIFTY_TERMS_AU;
        break;

      default:
        termsAndConditionsUrl = constants.HERTZ_TERMS_AU_PDF;
        break;

    }
  }

  switch (brand) {
    case "Ace":
      icon_Url_Complete1 = constants.ACE_COMPLETE_ICON_1;
      themeColor = constants.ACE_THEME_COLOR
      break;
    case "Ace":
      icon_Url_Complete1 = constants.ACE_COMPLETE_ICON_1;
      themeColor = constants.ACE_THEME_COLOR
      break;
    case "Dollar":
      icon_Url_Complete1 = constants.DOLLAR_COMPLETE_ICON_1;
      themeColor = constants.DOLLAR_THEME_COLOR
      break;
    case "Thrifty":
      icon_Url_Complete1 = constants.THRIFTY_COMPLETE_ICON_1;
      themeColor = constants.THRIFTY_THEME_COLOR
      break;
    default:
      icon_Url_Complete1 = constants.HERTZ_COMPLETE_ICON_1;
      themeColor = constants.HERTZ_THEME_COLOR
      break;

  }

  return (
    <div>
      <SnackBar />
      <ThemeProvider theme={theme}>
        <Hidden>

          {isAdditionalDriver ? (
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="center"
              style={{ marginTop: 40, padding: 30 }}
            >

              <Grid item>
                <img className={classes.icon} src={icon_Url_Complete1} />
              </Grid>
              {checkin.hasValidResult? <Grid item  style={{ textAlign: "center", marginBottom: 0 }}>
                <Typography variant={"h4"} style={{ marginBottom: 8 }} className={classes.bold}>Your details are up to date!</Typography>
                <Typography variant={"h4"} className={classes.bold}>Your driver&apos;s licence was verified on {verifiedTime}</Typography>
              </Grid>:<Grid item  style={{ textAlign: "center", marginBottom: 0 }}>
                <Typography variant={"h2"} className={classes.bold}>Your details as an additional driver are updated!</Typography>
              </Grid>}
            </Grid>
          ) : (
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="center"
              style={{ marginTop: 10, padding: 30 }}
            >

              <Grid item>
                <Typography variant={"h2"} className={classes.bold}>Thanks for checking in!</Typography>
              </Grid>
              <Grid item style={{margin: "25px 0"}}>
                <img className={classes.icon} src={icon_Url_Complete1} />
              </Grid>
              <Grid item style={{ textAlign: "center", marginBottom: 0, padding: "0 5%" }}>
                <Typography style={{fontSize: 16}} variant={"h4"}>If you are eligible for counter bypass, an SMS will be sent prior to your collection time with details on accessing your vehicle.</Typography>
              </Grid>
              <Grid item style={{ textAlign: "center", marginTop: 15, marginBottom: 0, padding: "0 5%" }}>
                <Typography style={{fontSize: 16}} variant={"h4"}>If you do not receive this SMS, or are not eligible for counter bypass, please head in store to our Express or Loyalty counters to collect your vehicle.</Typography>
              </Grid>
              <Grid style={{ width: '100%', marginTop: 15, marginBottom: 15, display: 'flex', alignItems: 'center' }}>
                <Divider style={{ width: '100%', backgroundColor: `${themeColor}`, height: 2 }} />
              </Grid>
              <Grid item style={{ textAlign: "center", padding: "0 5%" }}>
                <Typography style={{fontSize: 16}} variant={"h4"}>On the day of your rental, please remember to bring:</Typography>
              </Grid>

              <Grid style={{ display: "flex", justifyContent:"center", textAlign: "left", marginTop: 15 }}>
                <KeyboardArrowRightSharpIcon style={{color: `${themeColor}`, fontSize:"35px"}} />
                <Typography variant={"h4"}  style={{lineHeight: "2", fontSize: 16}} >Your current driver’s licence</Typography>
              </Grid>
              <Grid style={{ display: "flex", justifyContent:"center", textAlign: "left", marginBottom: 15 }}>
                <KeyboardArrowRightSharpIcon style={{color: `${themeColor}`, fontSize:"35px"}} />
                <Typography variant={"h4"} style={{lineHeight: "2", fontSize: 16}}>A credit or debit card in your name</Typography>
              </Grid>
              <Grid style={{ width: '100%', marginBottom: 15, display: 'flex', alignItems: 'center' }}>
                <Divider style={{ width: '100%', backgroundColor: `${themeColor}`, height: 2 }} />
              </Grid>
              <Grid item style={{ textAlign: "center", padding: "0 5%" }} id="t&c">
                <Typography style={{fontSize: 16}} variant={"h4"}>For more details regarding bonds and renters requirements, please see our <a href={termsAndConditionsUrl} download>terms and conditions.</a></Typography>
              </Grid>
            </Grid>)}
        </Hidden>

      </ThemeProvider>

      <Dialog open={willExpire && !letSessionExpire}>
        <DialogTitle style={{ textAlign: "center" }}>
          <IconButton aria-label="close" onClick={() => setLetSessionExpire(true)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>Your session will expire in 1 minute.</DialogContent>
        <DialogActions>
          <Divider />
          <Grid spacing={1} container direction="row" justify="center">
            <Grid container item xs={12} justify="center">
              <Fab color="primary" variant="extended" onClick={onExtendSession}>
                Extend My Session
              </Fab>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      {reservationNumber != "" && (
        <img
          src={`${apiURI}/pixel/${window.location.pathname.replace(/\//g, '_')}.png?b=${reservationNumber}&a=${"completed"}&country=${getCountryFromURL()}&c=${randomNumber}&brand=${brand}&t=${isAdditionalDriver?"additional_driver":"primary_driver"}`}
          style={{ display: "none" }}
        />
      )}
    </div>
  );
};

export default CheckinComplete;
